export const PERMS = {
    READ: 'service_workers.read',
    UPDATE: 'service_workers.update',
    DELETE: 'service_workers.delete',
    CREATE: 'service_workers.create',
    EXPORT: 'service_workers.export',
}
